import { StatTableCellProps } from "components/StatsTable/StatTableColumn";
import { StatTablePositionColumn } from "./PositionColumn";
import { positionNumberToText } from "Utility";
import { Position, PositionCell } from "./styles";

interface Props<T> extends StatTableCellProps<T, StatTablePositionColumn<T>> {}

export function StatTablePositionCell<T>({
  stats,
  column,
  columnIdx,
  frozenOffset,
}: Props<T>) {
  const position = column.positionGetter(stats);
  const positionText = !!position ? positionNumberToText(position) : "-";
  const accentColor = !!column.accentGetter
    ? column.accentGetter(stats)
    : undefined;
  return (
    <PositionCell
      key={`${columnIdx} position ${position}`}
      highlight={column.highlight}
      accentColor={accentColor}
      frozenWidth={column.frozenWidth}
      frozenOffset={frozenOffset}
      border={column.border}
    >
      <Position hasAccent={!!accentColor}>{positionText}</Position>
    </PositionCell>
  );
}
